import type { Lang } from '@/types/lang'
import type { Instruction } from '../types'
import { stripHtml } from './stripHtml'

type Slots = Pick<Instruction, 'title' | 'content' | 'titleEn' | 'contentEn'>

const filled = (title: string | null, content: string | null): boolean =>
  !!title?.trim() || !!stripHtml(content ?? '').trim()

/**
 * Язык, на котором открывается редактор статьи. По умолчанию — язык интерфейса
 * (английский интерфейс → английский слот, как у новых курсов). Исключение одно:
 * слот языка интерфейса пуст, а во втором есть текст — тогда второй, иначе автор
 * русской статьи при английском интерфейсе открывал бы пустую страницу.
 */
export const initialEditLang = (uiLang: Lang, instruction?: Slots): Lang => {
  if (!instruction) return uiLang
  const ru = filled(instruction.title, instruction.content)
  const en = filled(instruction.titleEn, instruction.contentEn)
  if (uiLang === 'en') return !en && ru ? 'ru' : 'en'
  return !ru && en ? 'en' : 'ru'
}
